export const formatRating = value => Number(value).toLocaleString('nl-NL', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});
